export default "__VITE_ASSET__7ceb1931__"